import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { useSelector } from 'react-redux'
import { getUserOrganization } from '../selectors/user'
import prepareHeaders from '../utils/prepareHeaders'

export const customerCollectionsApi = createApi({
  reducerPath: 'customerCollections',
  baseQuery: fetchBaseQuery({
    prepareHeaders,
    baseUrl: process.env.REACT_APP_AUGMENTT_API_URL,
  }),
  endpoints: (builder) => ({
    getCustomerCollections: builder.query({
      keepUnusedDataFor: 60,
      query: (organizationId) => `/organization/${organizationId}/customers/collections`,
      transformResponse: (responseData) => responseData?.collections,
    }),
  }),
})

export const { useGetCustomerCollectionsQuery } = customerCollectionsApi

export const useGetCustomerCollections = () => {
  const organizationId = useSelector(getUserOrganization)

  return useGetCustomerCollectionsQuery(organizationId)
}
